import { buildWhatsAppUrl, GENERAL_INQUIRY_MESSAGE, CONTACT_NAME } from "./kursusConstants";

function WhatsAppIcon(props) {
  return (
    <svg viewBox="0 0 32 32" fill="currentColor" {...props}>
      <path d="M16.001 2.667c-7.363 0-13.334 5.97-13.334 13.333 0 2.394.638 4.64 1.752 6.587L2.667 29.333l6.923-1.716a13.24 13.24 0 0 0 6.411 1.65c7.363 0 13.333-5.97 13.333-13.333S23.364 2.667 16.001 2.667zm0 24.267c-2.09 0-4.036-.578-5.706-1.583l-.409-.243-4.11 1.019 1.06-3.996-.267-.42a10.887 10.887 0 0 1-1.702-5.71c0-6.022 4.902-10.923 10.934-10.923 6.022 0 10.923 4.9 10.923 10.923 0 6.033-4.9 10.933-10.923 10.933zm5.988-8.186c-.328-.164-1.94-.958-2.24-1.066-.301-.11-.52-.164-.74.164-.219.328-.847 1.066-1.038 1.285-.191.219-.383.246-.71.082-.328-.164-1.384-.51-2.635-1.628-.974-.868-1.632-1.94-1.823-2.267-.191-.328-.02-.505.171-.669.192-.164.42-.42.63-.63.21-.21.278-.36.417-.6.14-.24.07-.45-.03-.628-.1-.178-.895-2.154-1.226-2.949-.32-.777-.647-.672-.888-.685-.226-.012-.485-.014-.746-.014-.26 0-.683.098-.94.46-.257.363-.98 1.056-.98 2.574s1.005 2.988 1.144 3.194c.14.207 1.917 2.915 4.648 3.969 2.732 1.055 2.732.703 3.222.66.49-.043 1.58-.646 1.803-1.271.223-.624.223-1.16.156-1.271-.066-.111-.243-.176-.507-.31z" />
    </svg>
  );
}

export function FloatingWhatsapp() {
  return (
    <a
      href={buildWhatsAppUrl(GENERAL_INQUIRY_MESSAGE)}
      target="_blank"
      rel="noreferrer"
      data-testid="kursus-floating-whatsapp"
      className="fixed bottom-24 lg:bottom-8 right-4 sm:right-6 z-40 flex items-center gap-2 bg-kursus-bg border-2 border-kursus-gold rounded-full pl-3.5 pr-4 py-2.5 shadow-[0_4px_24px_rgba(0,0,0,0.5)] hover:border-kursus-goldbright transition-colors"
    >
      <WhatsAppIcon className="w-5 h-5 text-[#25D366] shrink-0" />
      <span className="font-oswald text-xs font-bold text-kursus-white tracking-wide hidden sm:inline">TANYA {CONTACT_NAME.toUpperCase()}</span>
    </a>
  );
}
